import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { cumberlandRiConfig } from "./data";

export default function CumberlandRiPage() {
  return <CityPageTemplate config={cumberlandRiConfig} />;
}